import React from 'react'
import styled from 'styled-components'

const OfferDetails = ({ className, offer }) => {
  const fromLocation = offer.loading || offer.from
  const fromDate = offer.loadingDate || offer.fromDate
  const toLocation = offer.unloading || offer.to
  const toDate = offer.unloadingDate || offer.toDate
  const cargoDetails = [offer.container, offer.shipowner || offer.cargoType]
    .filter(Boolean)
    .join(', ')

  return (
    <div className={className}>
      <Text>
        {fromLocation ? `${fromLocation},` : ''}
        {fromDate ? <span>{`${fromDate}, `}</span> : ''}
        {toLocation ? `${toLocation}, ` : ''}{' '}
        {toDate ? <span>{`${toDate}, `}</span> : ''}
        {offer.startDate ? `${offer.startDate} - ` : ''}
        {offer.endDate ? `${offer.endDate}, ` : ''}
        {cargoDetails ? `${cargoDetails}, ` : ''}
        {offer.handlerCompany ? `${offer.handlerCompany}, ` : ''}
        {offer.handlerName ? `${offer.handlerName}, ` : ''}
        {offer.driver ? `${offer.driver}, ` : ''}
        {offer.driverPhone ? `${offer.driverPhone}` : ''}
      </Text>
    </div>
  )
}

export default styled(OfferDetails)`
  width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  min-height: 20px;
  line-height: 1;
`

const Text = styled.span`
  display: inline;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1;
  color: ${({ theme }) => theme.colors.ebonyClay.hex()};
  span {
    color: ${({ theme }) => theme.colors.ebonyClay.alpha(0.6).hex()};
  }
`
